export const toMeters = (distance: number, unitOfDistance: server.dto.UnitsOfDistance) => {
  if (unitOfDistance === "metric") {
    return distance * 1000;
  }

  return Math.round(distance * 1609.344);
};
